import { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Import useParams
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios"; // Import axios for API calls
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2";
import AllAgentTopUpRecord from "./DistributorComp/AllAgentTopUpRecord";

function AddAgentTopup() {
  const { agent_id } = useParams();  
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const distributorId = localStorage.getItem("distributor_id");

  const [isFetching, setIsFetching] = useState(true);
//   const distributorId = localStorage.getItem("distributor_id");
  const [walletBalance, setwalletBalance] = useState([]);  
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${baseurl}GetWalletTransactions/${distributorId}`);
       
        setwalletBalance(response.data.wallet_balance || []);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        
      }
      setIsFetching(false);
    };

    fetchTransactions();
  }, [distributorId]);




  // Handle modal show/hide
  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setAmount(""); // Reset input field
  };

  const handleSubmitAmount = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    setLoading(true);

    const requestData = {
      user_id: distributorId,
      agent_id: agent_id,  
      user_type: "agent",
      agent_id: agent_id,
      amount: amount,
      transaction_reason: `Wallet Top-Up for Agent ${agent_id} by Distributor ${distributorId}`,
    };

    console.log("Sending data:", requestData); // Log the request data

    try {
      const response = await axios.post(`${baseurl}AddToWalletAgent`, requestData); // API call

      console.log("Response:", response.data); // Log the response

      if (response.data.message === "Wallet updated successfully!") {
        Swal.fire({
          title: "Success!",
          text: response.data.transaction_reason,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to add amount.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    } catch (error) {
      console.error("Error adding amount:", error);
      Swal.fire({
        title: "Error!",
        text: "Error adding amount. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    setLoading(false);
    window.location.reload();
handleClose();
  

  };

  return (
    <>
      <DistributorNavbar />
      <div className="bgagent transaction-container">
        <div className="container-fluid">
          <div className="crdmain">
            <div className="text-end d-flex justify-content-end">
              <Button variant="primary" className="mb-3" onClick={handleShow}>
                Add Amount
              </Button>
            </div>

            <div className="transaction-card">
              <h2 className="title text-start">Agent/Distributor Wallet History</h2>

              <AllAgentTopUpRecord/>
            </div>
          </div>
        </div>
      </div>

      {/* Add Amount Modal */}
      <Modal show={showModal} onHide={handleClose} centered className="p-1  ">
        <Modal.Header closeButton>
          <Modal.Title className="p-0">Add Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-start">
  {/* Display Wallet Balance */}
  <div className="chart-title mb-3"><strong>Your Wallet Balance: ₹{walletBalance}</strong></div>

  {/* Input Field for Amount */}
  <label className="text-start">Enter Amount:</label>
  <input
    type="number"
    className="form-control mt-2"
    placeholder="Enter amount here"
    value={amount}
    onChange={(e) => {
      const enteredAmount = Number(e.target.value);

      if (enteredAmount > walletBalance) {
        // Show error if amount exceeds balance
        Swal.fire({
          title: "Insufficient Balance!",
          text: "Your wallet doesn't have enough balance to make this transaction. Please top up your wallet before proceeding.",
          icon: "warning",
          confirmButtonText: "OK",
        });

        setAmount(walletBalance); // Prevent entry of amount greater than balance
      } else {
        setAmount(enteredAmount); // Allow valid values
      }
    }}
  />

  {/* Show error message if amount exceeds balance */}
  {amount > walletBalance && (
    <p className="text-danger mt-2">❌ Not enough balance. Please top up your wallet.</p>
  )}
</Modal.Body>


        <Modal.Footer>
       
          <Button variant="primary" onClick={handleSubmitAmount} disabled={loading}>
            {loading ? "Processing..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddAgentTopup;
